var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.print_type,{tag:"component",attrs:{"sale":_vm.sale,"hasAddress":_vm.hasAddress,"hasPhones":_vm.hasPhones,"phones":_vm.phones}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }